import { baseService } from "../base";

export interface GracePeriodItem {
  id: string;
  inventoryRef: string;
  title: string;
  clientName: string;
  locationName?: string;
  locationRef?: string;
  locationId?: string;
  availableOnHandDate: string;
  gracePeriodEnd: Date;
  isInGracePeriod: boolean;
  hasBillingPeriod: boolean;
  daysInStatus: number;
}

export interface GracePeriodResponse {
  itemsInGracePeriod: GracePeriodItem[];
  itemsPastGracePeriod: GracePeriodItem[];
}

export interface InventoryBillingInvoice {
  id: string;
  invoiceNumber: string;
  client: {
    id: string;
    companyName: string;
  };
  inventory: {
    id: string;
    inventoryRef: string;
    title: string;
  };
  billingPeriod: {
    id: string;
    startDate: string;
    endDate?: string;
  };
  amount: number;
  status: string;
  date: string;
  description: string;
  notes?: string;
}

export interface GetInventoryBillingInvoicesRequest {
  page?: number;
  limit?: number;
  clientId?: string;
  status?: string;
  startDate?: string;
  endDate?: string;
  search?: string;
}

export interface GetInventoryBillingInvoicesResponse {
  invoices: InventoryBillingInvoice[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

// Get grace period status
export const getGracePeriodStatus = async (): Promise<GracePeriodResponse> => {
  const { data } = await baseService.get('/inventory-billing/grace-period-status');
  return data;
};

// Get inventory billing invoices
export const getInventoryBillingInvoices = async (
  params: GetInventoryBillingInvoicesRequest
): Promise<GetInventoryBillingInvoicesResponse> => {
  const { data } = await baseService.get("/inventory-billing/invoices", {
    params,
  });
  return data;
};

// Trigger billing checks
export const triggerBillingChecks = async () => {
  const { data } = await baseService.post('/inventory-billing/trigger-billing-checks');
  return data;
};

// Create missing invoices
export const createMissingInvoices = async (): Promise<{
  billingPeriodsChecked: number;
  invoicesCreated: number;
  errors: number;
}> => {
  const { data } = await baseService.get(
    "/inventory-billing/create-missing-invoices"
  );
  return data;
};

// Update location storage settings
export const updateLocationStorageSettings = async (): Promise<{
  locationsUpdated: number;
  errors: number;
}> => {
  const { data } = await baseService.post(
    "/inventory-billing/update-location-storage-settings"
  );
  return data;
};

export const inventoryBillingApi = {
  getGracePeriodStatus: () => baseService.get('/inventory-billing/grace-period-status'),
  
  triggerBillingChecks: () => baseService.post('/inventory-billing/trigger-billing-checks'),
  
  createMissingInvoices: () => baseService.get('/inventory-billing/create-missing-invoices'),

  getItemsWithoutLocation: () => baseService.get('/inventory-billing/items-without-location'),
};
